import moment from "moment"

// claude: gedeelde weergave-tijdzone (HSGA-204). Alle data wordt intern in UTC-milliseconden bijgehouden;
// deze module bepaalt alleen hoe tijden getoond worden: "utc" (standaard, gelijk aan FEWS/GMT) of "local"
// (tijdzone van de browser). Module-niveau i.p.v. alleen Redux, zodat ook niet-React code zoals de
// TimeDimension-control op de kaart (components/HKVMap/utils/functions.js) dezelfde keuze gebruikt.
export const TIME_MODES = ["utc", "local"]

let timeMode = "utc"

export const getTimeMode = () => timeMode

export const setTimeMode = (mode) => {
  timeMode = TIME_MODES.includes(mode) ? mode : "utc"
}

export const isUtcMode = () => timeMode === "utc"

export const formatTime = (value, format = "YYYY-MM-DD HH:mm") => {
  return isUtcMode() ? moment.utc(value).format(format) : moment(value).format(format)
}

// "UTC" of bv. "UTC+2" / "UTC+5:30" — offset per tijdstip, zodat zomer-/wintertijd klopt
// mode is optioneel, bv. om in de toggle het label van "local" te tonen terwijl UTC actief is
export const getTimeZoneLabel = (value = Date.now(), mode = timeMode) => {
  if (mode === "utc") return "UTC"

  const offset = moment(value).utcOffset()
  if (offset === 0) return "UTC"

  const sign = offset > 0 ? "+" : "-"
  const hours = Math.floor(Math.abs(offset) / 60)
  const minutes = Math.abs(offset) % 60
  return `UTC${sign}${hours}${minutes ? `:${String(minutes).padStart(2, "0")}` : ""}`
}
